import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LanguageService } from '../../../../core/services/language.service';
import { ModalPremiumPlusComponent } from '../../../modals/modal-premium-plus/modal-premium-plus.component';
import {
  ModalPodcastComponent,
  ModalPodcastData,
} from '../../../modals/modal-podcast/modal-podcast.component';
import { environment } from '../../../../../environments/environment';
import { IsApplicationService } from '../../../../core/services/is-application.service';
import { LinkService } from '../../../../core/services/link.service';
import { Podcast } from '../../../models/entities/podcast.entity';
import { Store } from '@ngrx/store';
import * as AuthSelectors from '../../../../core/state/auth-state/auth.selectors';
import { take } from 'rxjs';

@Component({
  selector: 'app-podcast-card',
  templateUrl: './podcast-card.component.html',
  styleUrls: ['./podcast-card.component.scss'],
})
export class PodcastCardComponent implements OnInit {
  @Input() podcast: Podcast;

  constructor(
    private matDialog: MatDialog,
    private store: Store,
    private isApplicationService: IsApplicationService,
    public languageService: LanguageService,
    private linkService: LinkService
  ) {}

  ngOnInit(): void {}

  openPodcastDetail() {
    if (this.podcast) {
      this.store
        .select(AuthSelectors.isPremiumPlus)
        .pipe(take(1))
        .subscribe((isPremiumPlus) => {
          if (!isPremiumPlus) {
            this.matDialog.open(ModalPremiumPlusComponent, {
              maxWidth: '100vw',
            });
            return;
          }

          if (!this.isApplicationService.isAppIos()) {
            const modalData: ModalPodcastData = {
              podcastId: this.podcast.id,
            };
            this.matDialog.open(ModalPodcastComponent, {
              maxWidth: '100vw',
              data: modalData,
            });
          } else {
            this.linkService.openBlank(
              `https://${environment.domain}/ios/podcasts/${this.podcast.id}`
            );
          }
        });
    }
  }
}
